import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import axios from 'axios';
import CountUp from 'react-countup';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

import { Bar } from 'react-chartjs-2';

import {
  FaUserGraduate,
  FaUsers,
  FaMoneyBillWave,
  FaWallet,
  FaBell,
  FaSearch
} from 'react-icons/fa';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function Dashboard() {

  const [data, setData] = useState({});

  useEffect(() => {

    axios.get(
      `${process.env.REACT_APP_API_URL}/dashboard`
    )
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      console.log(err);
    });

  }, []);

  const chartData = {
    labels: [
      'Students',
      'Parents',
      'Collected Fees',
      'Pending Fees'
    ],
    datasets: [
      {
        label: 'School Analytics',
        data: [
          data.total_students || 0,
          data.total_parents || 0,
          data.collected_fees || 0,
          data.pending_fees || 0
        ],
        backgroundColor: [
          '#6366f1',
          '#06b6d4',
          '#10b981',
          '#f59e0b'
        ],
        borderRadius: 15
      }
    ]
  };

  const cardStyle = {
    border: 'none',
    borderRadius: '24px',
    color: '#fff',
    padding: '25px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.08)'
  };

  return (

    <Layout>

      <div className="container-fluid">

        {/* Top Bar */}

        <div className="d-flex justify-content-between align-items-center mb-4">

          <div>

            <h1
              style={{
                fontWeight: '800',
                color: '#0f172a'
              }}
            >
              School ERP Dashboard
            </h1>

            <p
              style={{
                color: '#64748b'
              }}
            >
              Welcome Back Admin 👋
            </p>

          </div>

          <div className="d-flex align-items-center gap-3">

            <div
              style={{
                background: '#fff',
                padding: '10px 15px',
                borderRadius: '15px',
                boxShadow:
                  '0 5px 15px rgba(0,0,0,0.05)'
              }}
            >
              <FaSearch />
            </div>

            <div
              style={{
                background: '#fff',
                padding: '10px 15px',
                borderRadius: '15px',
                boxShadow:
                  '0 5px 15px rgba(0,0,0,0.05)'
              }}
            >
              <FaBell />
            </div>

            <div
              style={{
                background: '#6366f1',
                color: '#fff',
                padding: '10px 20px',
                borderRadius: '15px'
              }}
            >
              Admin
            </div>

          </div>

        </div>

        {/* KPI Cards */}

        <div className="row">

          <div className="col-md-3 mb-4">

            <div
              style={{
                ...cardStyle,
                background:
                  'linear-gradient(135deg,#6366f1,#8b5cf6)'
              }}
            >

              <div className="d-flex justify-content-between">

                <div>

                  <h6>Total Students</h6>

                  <h2>
                    <CountUp
                      end={data.total_students || 0}
                      duration={2}
                    />
                  </h2>

                </div>

                <FaUserGraduate size={42} />

              </div>

            </div>

          </div>

          <div className="col-md-3 mb-4">

            <div
              style={{
                ...cardStyle,
                background:
                  'linear-gradient(135deg,#06b6d4,#3b82f6)'
              }}
            >

              <div className="d-flex justify-content-between">

                <div>

                  <h6>Total Parents</h6>

                  <h2>
                    <CountUp
                      end={data.total_parents || 0}
                      duration={2}
                    />
                  </h2>

                </div>

                <FaUsers size={42} />

              </div>

            </div>

          </div>

          <div className="col-md-3 mb-4">

            <div
              style={{
                ...cardStyle,
                background:
                  'linear-gradient(135deg,#10b981,#22c55e)'
              }}
            >

              <div className="d-flex justify-content-between">

                <div>

                  <h6>Collected Fees</h6>

                  <h2>
                    ₹
                    <CountUp
                      end={data.collected_fees || 0}
                      duration={2}
                      separator=","
                    />
                  </h2>

                </div>

                <FaMoneyBillWave size={42} />

              </div>

            </div>

          </div>

          <div className="col-md-3 mb-4">

            <div
              style={{
                ...cardStyle,
                background:
                  'linear-gradient(135deg,#f97316,#f59e0b)'
              }}
            >

              <div className="d-flex justify-content-between">

                <div>

                  <h6>Pending Fees</h6>

                  <h2>
                    ₹
                    <CountUp
                      end={data.pending_fees || 0}
                      duration={2}
                      separator=","
                    />
                  </h2>

                </div>

                <FaWallet size={42} />

              </div>

            </div>

          </div>

        </div>

        {/* Quick Action Cards */}

        <div className="row mb-4">

          <div className="col-md-3">
            <div className="card p-3 text-center">
              ➕ Add Student
            </div>
          </div>

          <div className="col-md-3">
            <div className="card p-3 text-center">
              👨‍👩‍👧 Add Parent
            </div>
          </div>

          <div className="col-md-3">
            <div className="card p-3 text-center">
              💰 Collect Fee
            </div>
          </div>

          <div className="col-md-3">
            <div className="card p-3 text-center">
              📋 Attendance
            </div>
          </div>

        </div>

        {/* Charts */}

        <div className="row">

          <div className="col-md-8">

            <div
              className="card p-4"
              style={{
                borderRadius: '24px'
              }}
            >

              <h4
                style={{
                  fontWeight: '700'
                }}
              >
                School Analytics
              </h4>

              <Bar data={chartData} />

            </div>

          </div>

          <div className="col-md-4">

            <div
              className="card p-4"
              style={{
                borderRadius: '24px',
                height: '100%'
              }}
            >

              <h4>
                Quick Summary
              </h4>

              <hr />

              <p>
                👨‍🎓 Students :
                <strong>
                  {' '}
                  {data.total_students || 0}
                </strong>
              </p>

              <p>
                👨‍👩‍👧 Parents :
                <strong>
                  {' '}
                  {data.total_parents || 0}
                </strong>
              </p>

              <p>
                💰 Collected :
                <strong>
                  ₹{data.collected_fees || 0}
                </strong>
              </p>

              <p>
                ⚠ Pending :
                <strong>
                  ₹{data.pending_fees || 0}
                </strong>
              </p>

              <div
                style={{
                  background: '#eef2ff',
                  padding: '15px',
                  borderRadius: '15px',
                  marginTop: '20px'
                }}
              >

                <strong>
                  Today's Status
                </strong>

                <p
                  style={{
                    marginTop: '10px',
                    marginBottom: 0
                  }}
                >
                  School ERP running
                  successfully 🚀
                </p>

              </div>

            </div>

          </div>

        </div>

      </div>

    </Layout>

  );

}

export default Dashboard;